import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { Persona } from '@/components/PersonaSwitcher/types';

interface PersonaState {
  persona: Persona;
  setPersona: (persona: Persona) => void;
}

/**
 * Global persona store. Persona drives visual prioritisation
 * (Axioma VII — persona ≠ permission). Persisted to localStorage
 * so refresh keeps the user's choice.
 */
export const usePersona = create<PersonaState>()(
  persist(
    (set) => ({
      persona: 'todos',
      setPersona: (persona) => set({ persona }),
    }),
    { name: 'wiredesk-persona' },
  ),
);
